import { ID_PART_PATTERN, VERSION_SLUG_PATTERN } from "./instance-identity.js";
import { z } from "zod";
//#region src/instance-identity.schemas.ts
/**
* Zod schemas for fixture instance identity (plan 25 / 27).
*
* The identity is mostly enforced via runtime validator functions
* (`validateInstanceIdPart`, `validateVersionSlug` in `instance-identity.ts`),
* but the public types are derived from these schemas so the wire format
* stays in lockstep with the regexes used by the validators.
*/
const FixtureInstanceIdSchema = z.object({
	appId: z.string().regex(ID_PART_PATTERN).max(30),
	fixtureId: z.string().regex(ID_PART_PATTERN).max(24)
}).strict();
const FixtureVersionedInstanceIdSchema = z.object({
	appId: z.string().regex(ID_PART_PATTERN).max(30),
	fixtureId: z.string().regex(ID_PART_PATTERN).max(24),
	versionSlug: z.string().regex(VERSION_SLUG_PATTERN).max(16)
}).strict();
//#endregion
export { FixtureInstanceIdSchema, FixtureVersionedInstanceIdSchema };

//# sourceMappingURL=instance-identity.schemas.js.map